import { useCallback } from "react";

// Custom hook for file input functionality
export const useFileInput = (onFilesSelected: (files: FileList) => void) => {
  const openFileDialog = useCallback(() => {
    document.getElementById("file-input")?.click();
  }, []);

  const handleFileInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        onFilesSelected(e.target.files);
      }
    },
    [onFilesSelected]
  );

  return { openFileDialog, handleFileInputChange };
};

// Generate smaller thumbnail from URL - memoized
export const generateThumbnail = (imageUrl: string): Promise<string> => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.crossOrigin = "anonymous";
    img.onload = () => {
      // Set smaller thumbnail size for better performance
      const size = 80;
      canvas.width = size;
      canvas.height = size;

      // Calculate crop to maintain aspect ratio
      const scale = Math.max(size / img.width, size / img.height);
      const x = (size - img.width * scale) / 2;
      const y = (size - img.height * scale) / 2;

      ctx!.drawImage(img, x, y, img.width * scale, img.height * scale);
      resolve(canvas.toDataURL("image/jpeg", 0.6));
    };

    img.onerror = () => {
      // Fallback to original URL if thumbnail generation fails
      resolve(imageUrl);
    };

    img.src = imageUrl;
  });
};
